import type { Content, Emphasis } from 'mdast'
import * as React from 'react'

import { styled } from '~/styled'

type MarkdownEmphasisProps = {
  node: Emphasis
  handleNode: (node: Content) => React.ReactElement<unknown>
}

export const StyledMarkdownEmphasis = styled('em', {
  base: ['italic']
})

export const MarkdownEmphasis = ({
  node,
  handleNode
}: MarkdownEmphasisProps) => (
  <StyledMarkdownEmphasis>
    {node.children?.map(handleNode)}
  </StyledMarkdownEmphasis>
)
